module.exports = __webpack_public_path__ + "static/media/sgd-10.282855af.png";